// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  FilterOperandHolder,
  FilterOperandHolderT,
  verifyFilterOperandHolder,
} from "./filter-operand-holder";
import { FilterOperator } from "./filter-operator";

/**
 * One element of a where-clause content filter.
 */
export class ContentFilterElement implements flatbuffers.IUnpackableObject<ContentFilterElementT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ContentFilterElement {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsContentFilterElement(
    bb: flatbuffers.ByteBuffer,
    obj?: ContentFilterElement,
  ): ContentFilterElement {
    return (obj || new ContentFilterElement()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsContentFilterElement(
    bb: flatbuffers.ByteBuffer,
    obj?: ContentFilterElement,
  ): ContentFilterElement {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ContentFilterElement()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  operator(): FilterOperator {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : FilterOperator.Equals;
  }

  operands(index: number, obj?: FilterOperandHolder): FilterOperandHolder | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new FilterOperandHolder()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  operandsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startContentFilterElement(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addOperator(builder: flatbuffers.Builder, operator: FilterOperator) {
    builder.addFieldInt8(0, operator, FilterOperator.Equals);
  }

  static addOperands(builder: flatbuffers.Builder, operandsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, operandsOffset, 0);
  }

  static createOperandsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startOperandsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endContentFilterElement(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // operands
    return offset;
  }

  static createContentFilterElement(
    builder: flatbuffers.Builder,
    operator: FilterOperator,
    operandsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    ContentFilterElement.startContentFilterElement(builder);
    ContentFilterElement.addOperator(builder, operator);
    ContentFilterElement.addOperands(builder, operandsOffset);
    return ContentFilterElement.endContentFilterElement(builder);
  }

  unpack(): ContentFilterElementT {
    return new ContentFilterElementT(
      this.operator(),
      this.bb!.createObjList<FilterOperandHolder, FilterOperandHolderT>(
        this.operands.bind(this),
        this.operandsLength(),
      ),
    );
  }

  unpackTo(_o: ContentFilterElementT): void {
    _o.operator = this.operator();
    _o.operands = this.bb!.createObjList<FilterOperandHolder, FilterOperandHolderT>(
      this.operands.bind(this),
      this.operandsLength(),
    );
  }

  unpackFields(...fields: string[]): ContentFilterElementT {
    const t = new ContentFilterElementT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("operator")) {
      t.operator = this.operator();
    }
    if (fieldSet.has("operands")) {
      t.operands = this.bb!.createObjList<FilterOperandHolder, FilterOperandHolderT>(
        this.operands.bind(this),
        this.operandsLength(),
      );
    }
    return t;
  }
}

export class ContentFilterElementT implements flatbuffers.IGeneratedObject {
  constructor(
    public operator: FilterOperator = FilterOperator.Equals,
    public operands: FilterOperandHolderT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.operands === null || this.operands === undefined) {
      throw new Error('Required field "operands" is not set');
    }
    const operands = ContentFilterElement.createOperandsVector(
      builder,
      builder.createObjectOffsetList(this.operands),
    );

    return ContentFilterElement.createContentFilterElement(builder, this.operator, operands);
  }

  clone(): ContentFilterElementT {
    const obj = new ContentFilterElementT();
    obj.operator = this.operator;
    obj.operands = this.operands.map((e) => e.clone());
    return obj;
  }

  equals(other: ContentFilterElementT): boolean {
    if (this.operator !== other.operator) return false;
    if (this.operands.length !== other.operands.length) return false;
    for (let i = 0; i < this.operands.length; i++) {
      const a = this.operands[i];
      const b = other.operands[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyContentFilterElement(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyFilterOperandHolder);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "operands");
  } finally {
    verifier.popDepth();
  }
}
